/**
 * Capacitor plugin for sharing content in any sharing-enabled apps the user may have installed.
 * Reference docs used to derive types & behavior:
 *   https://www.npmjs.com/package/@capacitor/share
 */
import { mobilePlugins } from "@/shared/mobileHelper";
import { Directory, downloadFile } from "@/shared/nativePlugins/fileHelper";
import * as datadog from "@/shared/datadog";

/** Show a Share modal for sharing content with other apps
 * @param url - full url of a file to share
 */
export async function shareUrl (url: string) {
  try {
    const { value: canShare } = await mobilePlugins.Share.canShare();
    if (!canShare) {
      datadog.log("Mobile share failed. Share functionality is not supported on the device.", {}, "info");
      (window as any).navigator.notification.alert("Share functionality is not supported.", null, "Unable to share!");
      return;
    }
    const downloadFileResult = await downloadFile({ url, directory: Directory.Temporary, trackProgress: false });
    await mobilePlugins.Share.share({ url: downloadFileResult.path });
  } catch (err) {
    if (err instanceof Error) {
      if (err.message.includes("canceled")) {
        return Promise.resolve();
      }
    }
    datadog.log("Mobile share error.", err, "error");
    throw err;
  }
}